import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { SigninRedirectCallbackComponent } from 'src/auth/signin-redirect-callback/signin-redirect-callback.component';
import { SignoutRedirectCallbackComponent } from 'src/auth/signout-redirect-callback/signout-redirect-callback.component';
import { SplashModule } from 'src/splash/splash.module';
import { AppContainerComponent } from './app-container/app-container.component';
import { HomeComponent } from './home/home.component';
import { AzdeCertRouteReuseStrategy } from './azde-cert-route-reuse.strategy';
import { IsLoggedInGuard } from './route-guards/is-logged-in.guard';
import { allowedPortalMatchGuard } from './allowed-portal-match.guard';
import { certLandingGuard } from './cert-landing.guard';
import { EmptyLandingComponent } from './empty-landing/empty-landing.component';

const appRoutes: Routes = [
  {
    path: 'launch',
    loadChildren: () => SplashModule,
  },
  {
    path: '',
    component: AppContainerComponent,
    canActivate: [IsLoggedInGuard],
    children: [
      {
        path: 'cert',
        canActivate: [certLandingGuard],
        component: EmptyLandingComponent,
        pathMatch: 'full',
      },
      {
        path: 'user-type-selection',
        component: HomeComponent,
        title: 'User Type Selection',
      },
      {
        path: 'cert/no-home',
        component: EmptyLandingComponent,
        title: 'Home',
      },
      {
        path: 'cert/help',
        loadChildren: () => import('../help/help.module').then((m) => m.HelpModule),
      },
      {
        path: 'cert/contacts',
        loadChildren: () => import('../contacts/contacts.module').then((m) => m.ContactsModule),
      },
      {
        path: 'lea',
        canMatch: [allowedPortalMatchGuard],
        loadChildren: () => import('../lea/lea.module').then((m) => m.LeaModule),
      },
      {
        path: 'epp',
        canMatch: [allowedPortalMatchGuard],
        loadChildren: () => import('../epp/epp.module').then((m) => m.EppModule),
      },
      {
        path: 'lea2',
        canMatch: [allowedPortalMatchGuard],
        loadChildren: () => import('../lea2/lea2.module').then((m) => m.Lea2Module),
      },
      {
        path: 'cert/lab',
        canMatch: [allowedPortalMatchGuard],
        loadChildren: () => import('../lab/lab.module').then((m) => m.LabModule),
      },
      {
        path: 'cert/educators',
        canMatch: [allowedPortalMatchGuard],
        loadChildren: () => import('../educators/educators.module').then((m) => m.EducatorsModule),
      },
      {
        path: 'cert/admin',
        canMatch: [allowedPortalMatchGuard],
        loadChildren: () => import('src/admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'cert/services',
        canMatch: [allowedPortalMatchGuard],
        loadChildren: () =>
          import('src/service-evaluations/service-evaluations.module').then((m) => m.ServiceEvaluationsModule),
      },
      {
        path: 'cert/payments',
        canMatch: [allowedPortalMatchGuard],
        loadChildren: () => import('src/payments/payments.module').then((m) => m.PaymentsModule),
      },
      {
        path: 'cert/discipline',
        canMatch: [allowedPortalMatchGuard],
        loadChildren: () => import('src/discipline/discipline.module').then((m) => m.DisciplineModule),
      },
    ],
  },
  { path: 'signin-callback', component: SigninRedirectCallbackComponent },
  { path: 'signout-callback', component: SignoutRedirectCallbackComponent },
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(appRoutes, {
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
      enableViewTransitions: true,
    }),
  ],
  providers: [{ provide: RouteReuseStrategy, useClass: AzdeCertRouteReuseStrategy }],
  exports: [RouterModule],
})
export class AppRoutingModule {}
